import type { RouteRecordRaw } from 'vue-router';

import { AUTH_ROUTE_NAME, LAYOUT_AUTH } from '~~/router/router.entity';

const loginRoute: RouteRecordRaw = {
  name: AUTH_ROUTE_NAME,
  path: '/auth',
  redirect: '/auth/login',
  component: LAYOUT_AUTH,
  meta: {
    title: 'Auth',
    ignoreAuth: true,
    hideInMenu: true,
  },
  children: [
    {
      component: () => import('~~/pages/auth/login.vue'),
      path: 'login',
      name: '/auth/login',
      meta: {
        title: 'Login',
        i18nKey: 'routes.auth.login',
      },
    },
    {
      component: () => import('~~/pages/auth/new-password.vue'),
      path: 'new-password',
      name: '/auth/new-password',
      meta: {
        title: 'New Password',
        i18nKey: 'routes.auth.newPassword',
      },
    },
  ],
};

export default loginRoute;
